// extracted by mini-css-extract-plugin
module.exports = {"unorderListItems":"UnorderListItems_unorderListItems__ps15P"};